import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { getGenres } from '../../actions/filterActions';

const GenreFilterComponent = (props) => {

    const dispatch = useDispatch()

    const {error, loading, genres, message} = useSelector(state => state.genres)

    React.useEffect(()=>{
    
        if(props.lastChangedComponent !== props.componentId ){
            dispatch(getGenres(props.filterList))
        }
    
    },[props.filterList])


    const chooseHandler = (genre) => {
        if (props.filterList.filter(g => g[0] === genre.id && g[2] === props.componentId ).length === 0 ){
            props.setFilterList((prevArr)=>{ return[...prevArr, [genre.id, genre.title, props.componentId]]})
        } else{
            props.setFilterList((prevArr) => 
                prevArr.filter(item => item[0] !== genre.id)
            )
        }
        props.setLastChangedComponent(props.componentId)
    }

    return (
        <div className = "w-100 d-flex flex-column py-4">
            {
                loading ? 
                <div className='w-100 text-info position-relative p-2 rounded'
                    style={{zIndex:'1000'}}
                >Loading...</div> :
                genres && genres.length ?
                <div className = "w-100 position-relative mt-3 p-2 d-flex gap-2 flex-wrap rounded " 
                    style = {{color:"#333", zIndex:1000}}
                    >
                        {
                        genres.map((result) => (
                            <div

                                role = "button"
                                className = 
                                {
                                    props.filterList.some(component => component[0] === result.id && component[2] === props.componentId) ?
                                    "py-1 px-4 text-backcolor text-center rounded-pill bg-info" : 
                                    "py-1 px-4 text-info text-center rounded-pill bg-blueazur"
                                }                                style={{transition:"all 0.2s"}}
                                key = {result.id}
                                onClick={()=>chooseHandler(result)}
                            >
                                {result.title}
                            </div>
                        ))
                        }
                </div> : 
                message ?
                <div className='w-100 text-info position-relative p-2 rounded'>
                    {message}
                </div> : ""
            }
        </div>
    );
};

export default GenreFilterComponent;